export interface School {
  id: string
  name: string
  location: string
  description: string
  accreditation: string
  programsOffered: string[]
  rating: number
  onlineOnly: boolean
  featured: boolean
}

export const mockSchools: School[] = [
  {
    id: 'snhu',
    name: 'Southern New Hampshire University',
    location: 'Manchester, NH (Online)',
    description:
      'SNHU offers over 200 flexible online degree programs designed for working adults. Experience affordable tuition and dedicated student support.',
    accreditation: 'NECHE Accredited',
    programsOffered: [
      'Business',
      'Computer Science',
      'Healthcare',
      'Psychology',
      'Liberal Arts',
    ],
    rating: 4.8,
    onlineOnly: false,
    featured: true,
  },
  {
    id: 'purdue-global',
    name: 'Purdue Global',
    location: 'West Lafayette, IN (Online)',
    description:
      'Built for working adults, Purdue Global offers online degrees backed by the Purdue University system. Get credit for your work experience.',
    accreditation: 'HLC Accredited',
    programsOffered: [
      'Business',
      'IT',
      'Nursing',
      'Criminal Justice',
      'Education',
    ],
    rating: 4.7,
    onlineOnly: true,
    featured: true,
  },
  {
    id: 'wgu',
    name: 'Western Governors University',
    location: 'Salt Lake City, UT (Online)',
    description:
      "WGU's competency-based education lets you move faster through material you already know. Flat-rate tuition helps you save.",
    accreditation: 'NWCCU Accredited',
    programsOffered: [
      'Teachers College',
      'College of Business',
      'College of IT',
      'College of Health',
    ],
    rating: 4.9,
    onlineOnly: true,
    featured: true,
  },
  {
    id: 'gcu',
    name: 'Grand Canyon University',
    location: 'Phoenix, AZ (Online)',
    description:
      'A premier private Christian university offering online degree programs in high-demand fields with generous transfer policies.',
    accreditation: 'HLC Accredited',
    programsOffered: [
      'Nursing',
      'Education',
      'Business',
      'Criminal Justice',
      'Engineering',
    ],
    rating: 4.6,
    onlineOnly: false,
    featured: false,
  },
  {
    id: 'liberty',
    name: 'Liberty University',
    location: 'Lynchburg, VA (Online)',
    description:
      'One of the largest Christian universities in the world, offering 100% online programs with 8-week courses and no set login times.',
    accreditation: 'SACSCOC Accredited',
    programsOffered: [
      'Aviation',
      'Business',
      'Counseling',
      'Divinity',
      'Education',
    ],
    rating: 4.5,
    onlineOnly: false,
    featured: false,
  },
]
